<footer *ngIf="isVisible" style="">
  &emsp;
  <br>
  &emsp;
  <br>
  <p style="color:#1c7430; justify-content: flex-end">V{{ displayedVersion }}</p>
</footer>
